import JSONWrapper from './json-wrapper'
import { ValidationError } from './error'
import elementsSchema from '../../../public/json/elements.schema.json'
import typeSchema from '../../../public/json/types.json'
import defaultDrawing from './defaults/default_drawing'
import defaultActions from './defaults/default_actions'

/* eslint-disable no-param-reassign */

/**
 * Коллекция элементов пульта
 *
 * @extends {JSONWrapper}
 */
class ElementsCollection extends JSONWrapper {
  constructor(data) {
    super(data, ['itemsById'], [defaultDrawing, defaultActions])
    this.setSchemas(elementsSchema, [typeSchema])
    this.codeAccessor = (o) => o.code
  }

  afterObjectSet() {
    this.updateItems()
    this.importCode((o) => o.code)
  }

  validateItems(object, params) {
    object = object || this.object
    const errors = []
    const usedItemIds = new Set()
    object.items.forEach((item, index) => {
      const path = `/items/${index}`
      if (usedItemIds.has(item.id)) {
        errors.push(new ValidationError(`Элемент {id: ${item.id}} уже существует в коллекции`, null, `${path}/id`))
      } else {
        usedItemIds.add(item.id)
      }
      if (!this.moduleHasExport(item.displayFunction, params.module)) {
        errors.push(new ValidationError(`Функция "${item.displayFunction}" не найдена в коде`, null, `${path}/displayFunction`))
      }
      if (item.activeZones) {
        item.activeZones.forEach((activeZone, zoneIndex) => {
          if (!this.moduleHasExport(activeZone.function, params.module)) {
            errors.push(new ValidationError(`Функция "${activeZone.function}" не найдена в коде`, null, `${path}/activeZones/${zoneIndex}/function`))
          }
        })
      }
      errors.push(...this.validateLayers(item, path, params))
    })
    return errors
  }

  validateLayers(item, path, params) { // eslint-disable-line class-methods-use-this
    const errors = []
    item.layers.forEach((layer, layerIndex) => {
      const layerPath = `${path}/layers/${layerIndex}`
      if (Number.isInteger(layer.texture) && !params.resources.texturesById[layer.texture]) {
        errors.push(new ValidationError(`Текстуры {id: ${layer.texture}} не существует`, null, `${layerPath}/texture`))
      } else if (!Number.isInteger(layer.texture)) {
        const tileset = params.resources.tilesets[layer.texture.tileset]
        if (!tileset) {
          errors.push(new ValidationError(`Тайлсета {id: ${layer.texture.tileset}} не существует`, null, `${layerPath}/texture/tileset`))
        } else if (!tileset.hasItem(layer.texture.textureName)) {
          errors.push(new ValidationError(
            `Текстуры с именем "${layer.texture.textureName}" в тайлсете {id: ${layer.texture.tileset}} не существует`,
            null,
            `${layerPath}/texture/textureName`,
          ))
        }
      }
    })
    return errors
  }

  validateObject(object, params) {
    object = object || this.object
    params = params || {}
    const schemaErrors = super.validateObject(object, params)
    if (schemaErrors.length > 0) {
      return schemaErrors
    }
    return [
      ...this.validateItems(object, params)
    ]
  }

  updateItems() {
    this.itemsById = {}
    this.items.forEach((item) => {
      this.itemsById[item.id] = item
    })
  }
}

export default ElementsCollection
